import { LowerCasePipe } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { OnyxBadgeComponent } from '@onyx/angular';
import { ContractorHelper } from '../../../../contractors/common/helpers/contractor.helper';
import type { SimplifiedContractor } from '../../../../contractors/common/interfaces/contractor';
import type { PointOfInterest } from '../../interfaces/point-of-interest';

@Component({
  selector: 'app-points-of-interest-assigned-contractors-cell',
  imports: [LowerCasePipe, TranslatePipe, OnyxBadgeComponent],
  templateUrl: './points-of-interest-assigned-contractors-cell.component.html',
  styleUrl: './points-of-interest-assigned-contractors-cell.component.scss',
})
export class PointsOfInterestAssignedContractorsCellComponent {
  private readonly contractorHelper = inject(ContractorHelper);

  public readonly contractors = input.required<
    PointOfInterest['contractors'][number][] | null
  >();

  protected openModal(contractor: SimplifiedContractor): void {
    this.contractorHelper.openModal(contractor);
  }
}
